import { Session } from '@/lib/next-shim'
import CubeSanteLandingClient from './CubeSanteLandingClient'

type CubeSanteLandingPageProps = {
    session?: Session
}

export default function CubeSanteLandingPage({ session }: CubeSanteLandingPageProps) {
    return <CubeSanteLandingClient session={session} />
}
